import StripeSmall from '../icons/StripeSmall.jsx';

export const paymentItems = [
  /* { id: 1, name: "Mercado Pago", icon: <MercadoPagoSmall/>, key: "mercadopago" } */
  { id: 2, name: 'Stripe', icon: <StripeSmall />, key: 'stripe' }
];
